import React, { useState, useRef } from "react";
import Header from "../components/Header";
import Document from "../components/UploadForm";
import DocFooter from "../components/DocFooter";
import ReqFooter from "../components/ReqFooter";
import ReactRemoveScroll from "react-remove-scroll/dist/es5/Combination";
import RequisitesForm from "../components/RequisitesForm";

function MainPage() {
    const [isReq, setIsReq] = useState(false);
    const [dx, setDx] = useState(0);          // live finger offset (px)
    const [dragging, setDragging] = useState(false);
    const start = useRef({ x: 0, y: 0, axis: null });

    const go = (req) => setIsReq(req);

    const onTouchStart = (e) => {
        const t = e.touches[0];
        start.current = { x: t.clientX, y: t.clientY, axis: null };
        setDragging(true);
    };

    const onTouchMove = (e) => {
        const t = e.touches[0];
        let mdx = t.clientX - start.current.x;
        const mdy = t.clientY - start.current.y;

        if (start.current.axis === null) {
            if (Math.abs(mdx) > 8 || Math.abs(mdy) > 8) {
                start.current.axis = Math.abs(mdx) > Math.abs(mdy) ? "x" : "y";
            }
        }
        if (start.current.axis !== "x") return; // vertical -> scroll

        if ((!isReq && mdx > 0) || (isReq && mdx < 0)) mdx *= 0.25; // rubber-band at edges
        setDx(mdx);
    };

    const onTouchEnd = () => {
        const axis = start.current.axis;
        setDragging(false);
        const th = 60;
        if (axis === "x") {
            if (!isReq && dx < -th) setIsReq(true);
            else if (isReq && dx > th) setIsReq(false);
        }
        setDx(0);
    };

    const base = isReq ? -50 : 0; // percent of the 200%-wide track
    const trackStyle = {
        transform: `translateX(calc(${base}% + ${dx}px))`,
        transition: dragging ? "none" : "transform 0.3s ease",
    };

    // swipe progress 0 (Документ) -> 1 (Реквизиты); drives the sliding header pill
    const vw = typeof window !== "undefined" ? window.innerWidth || 1 : 1;
    let progress = (isReq ? 1 : 0) + -dx / vw;
    progress = Math.max(0, Math.min(1, progress));

    return (
        <div className="container">
            <Header isReq={isReq} onSelect={go} progress={progress} dragging={dragging} />
            <ReactRemoveScroll className="middle">
                <div
                    className="swipe-area"
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                >
                    <div className="swipe-track" style={trackStyle}>
                        <div className="page">
                            <div className="page-content"><Document /></div>
                            <DocFooter />
                        </div>
                        <div className="page">
                            <div className="page-content"><RequisitesForm /></div>
                            <ReqFooter />
                        </div>
                    </div>
                </div>
            </ReactRemoveScroll>
        </div>
    );
}

export default MainPage;
